import { ProductClass } from '@mortgage-pos/types'

const JUMBO_PRODUCT_CLASSES = [
  ProductClass.Jumbo,
  ProductClass.JumboIo,
  ProductClass.StreamlineIrrrlJumbo,
] as const

export function isJumboProductClass(
  productClass: ProductClass | string | null | undefined
): boolean {
  if (!productClass) {
    return false
  }

  return (JUMBO_PRODUCT_CLASSES as readonly string[]).includes(productClass)
}
